import {
    ExtendedConstructionNumber,
    ExtendedPropertyType,
} from '../../api-utilities/api-utilities.types';

interface IsApartment {
    (obj: { constructionNumber: ExtendedConstructionNumber }): boolean;
    (obj: { propertyType: ExtendedPropertyType }): boolean;
}

const isApartment: IsApartment = ({
    constructionNumber,
    propertyType,
}: {
    constructionNumber?: ExtendedConstructionNumber;
    propertyType?: ExtendedPropertyType;
}): boolean => {
    let houseType: string | undefined | null;

    if (propertyType) {
        houseType = propertyType.houseType;
    }

    if (constructionNumber) {
        houseType = constructionNumber.propertyType?.houseType;
    }

    return ['Appartement', 'Loft', 'Maisonette', 'Studio'].includes(houseType || '');
};

export { isApartment };
